import classnames from 'classnames';

import { onEnter } from '../../../utils';
import Flex from '../../generic/Flex';
import Icon, { icons } from '../../generic/Icon';

type OrgCreateOrJoinSelectorProps = {
  showOrganizationPicker: boolean;
  toggleShowOrganizationPicker: (showOrganizationPicker: boolean) => void;
};

/**
 * Selector allowing users to either join an existing org or create a new one.
 * This would only ever be shown to on-prem customers.
 *
 * @param {boolean} showOrganizationPicker - If the "Join existing" option is selected.
 * @param {(showOrganizationPicker: boolean) => void} toggleShowOrganizationPicker - Toggle the state between "Join existing" and "Create new"
 */
const OrgCreateOrJoinSelector = ({
  showOrganizationPicker,
  toggleShowOrganizationPicker,
}: OrgCreateOrJoinSelectorProps) => (
  <div className="fossa-auth__onboarding__create-or-join-selector">
    <div
      className={classnames('fossa-auth__onboarding__create-or-join-selector__option', {
        selected: showOrganizationPicker,
      })}
      onClick={() => toggleShowOrganizationPicker(true)}
      role="button"
      onKeyPress={onEnter(() => toggleShowOrganizationPicker(true))}
      tabIndex={0}
    >
      <Flex justify="space-between">
        <span>Join an existing company</span>
        {showOrganizationPicker && <Icon icon={icons.checkCircle} />}
      </Flex>
    </div>
    <div
      className={classnames('fossa-auth__onboarding__create-or-join-selector__option', {
        selected: !showOrganizationPicker,
      })}
      onClick={() => toggleShowOrganizationPicker(false)}
      onKeyPress={onEnter(() => toggleShowOrganizationPicker(false))}
      role="button"
      tabIndex={0}
    >
      <Flex justify="space-between">
        <span>Create a new company</span>
        {!showOrganizationPicker && <Icon icon={icons.checkCircle} />}
      </Flex>
    </div>
  </div>
);

export default OrgCreateOrJoinSelector;
